// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__33vYH","label":"LabeledBox_label__bQ4dR"};